import { type FC } from "react";
import { Link } from "react-router";

import { WorkflowMark } from "@styled/workflow_mark";

import { type Segment } from "./segment_copy";

// The nav offers three of the four segments, under shorter singular labels than
// the chips in segments.tsx use. Practice management is deliberately absent.
const NAV_SEGMENTS: { segment: Segment; label: string }[] = [
  { segment: "medical", label: "Medical Expert" },
  { segment: "legal", label: "Legal Expert" },
  { segment: "claims", label: "Insurance & Risk Expert" },
];

// Markup transcribed from the design port kit (sections/Nav.html). Class names
// are the contract — home.css styles them; do not substitute utilities.
export const Nav: FC<{ onSelect: (segment: Segment) => void }> = ({
  onSelect,
}) => (
  <nav>
    <div className="navin">
      <div className="logo">
        <WorkflowMark />
        <span className="lcaps">WORKFLOW LABS</span>
      </div>
      <div className="navright">
        {NAV_SEGMENTS.map(({ segment, label }) => (
          <a
            key={segment}
            href="#who"
            data-seg={segment}
            onClick={() => onSelect(segment)}
          >
            {label}
          </a>
        ))}
        {/* Rails renders /blog, and routes.tsx has no route for it — a
            react-router <Link> would try to navigate the SPA and land nowhere. */}
        <a href="/blog">Blog</a>
        <Link to="/login">Login</Link>
      </div>
    </div>
  </nav>
);
